export const version = process.env.REACT_APP_VERSION
export const commit = process.env.REACT_APP_COMMIT?.substring(0, 8)
